import styles from "./myHeader.module.scss";
import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import utils from "../../../utils";
import store from "../../../redux/Store";
import { Modal } from "antd";
const buyLinkName = "Add Credits";

const MyHeader = () => {
  const router = useRouter();
  const [login, setLogin] = useState(false);
  const [active, setActive] = useState();
  const [homeNav, setHomeNav] = useState(
    router.pathname === "/" ? "homeNavnotFixed" : "homeNavFixed"
  );
  const isHome = router.pathname === "/" ? true : false;
  let isAppleDevice = false
  if (typeof window !== 'undefined') {
    isAppleDevice = !!(window.navigator.userAgent.toLocaleLowerCase().match(/ios|ipad|iphone|mac/));
  }
  // console.log('1111111', isAppleDevice)
  const urlArr = [
    {
      name: "Phone Number",
      path: "/phone-number.html",
    },
    {
      name: "Free Calls & Texts",
      path: "/free-calls-and-free-texts.html",
    },
    {
      name: "Rate & Plan",
      path: "/rates-plans.html",
    },
    {
      name: "Download",
      path: "/dingtone-free-download.html",
    },
    {
      name: buyLinkName,
      path: "https://og.dingtone.me/en/buy/",
    },
  ];
  // 初始化导航选中状态
  const getCurrentPath = (path) => {
    return urlArr.filter((item) => {
      return item.path.includes(path);
    });
  };
  // 设置菜单初始化样式
  const setNav = () => {
    if (getScrollTop() > 1000) {
      setHomeNav("homeNavFixed");
    } else {
      setHomeNav("homeNavnotFixed");
    }
  };
  // 获取滚动条的高度
  const getScrollTop = () => {
    var scroll_top = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
      scroll_top = document.documentElement.scrollTop;
    } else if (document.body) {
      scroll_top = document.body.scrollTop;
    }
    // console.log(scroll_top)
    return scroll_top;
  };

  useEffect(() => {
    // goMobile();
    if (router.pathname != "/" && getCurrentPath(router.pathname).length > 0) {
      setActive(getCurrentPath(router.pathname)[0].path);
    }
    if (utils.isLogin() === 1) {
      setLogin(true);
    }

    store.subscribe(() => {
      let { isLogin } = store.getState();
      // console.log("Subscribe:", isLogin);
      if (isLogin) {
        setLogin(true);
      }
    });

    window.onscroll = () => {
      if (router.pathname === "/") {
        setNav();
      }
    };
  }, []);

  return (
    <header
      className={styles.header + " " + styles[isHome ? homeNav : "notHomeNav"]}
    >
      <div className="main">
        <div className="navList">
          <ul>
            <li>
              <Link href="http://blog.dingtone.me/en/">
                <a>Blog</a>
              </Link>
            </li>
            <li>
              <span>|</span>
            </li>
            <li>
              <Link href="http://www.twitter.com/dingtone">
                <a>Twitter</a>
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.bottomNav}>
          <Link href="/">
            <a>
              <img className={styles.logo} src="/img/nav_logo.png" alt="logo" />
              <img className={styles.logoBg} src="/img/nav_logo_bg.png" alt="logo" />
            </a>
          </Link>
          <ul>
            {urlArr.map((item, index) => (
              <li
                className={styles[active === item.path ? "active" : ""]}
                key={index}
              >
                {isAppleDevice && item.name===buyLinkName ?
                ''
                :
                <Link href={item.path}>
                  <a>{item.name}</a>
                </Link>
                }
              </li>
            ))}

            <li className={styles.my}>
              <Link href="/my/home">
                <a style={{ width: "40px", height: "40px" }}>
                  {!login && <img src="/img/icon_login.png" alt="" />}
                  {login && <img src="/img/icon_account@2x.png" alt="" />}
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};
export default MyHeader;
